import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FooterComponent,
  FooterColumnComponent,
} from './footer.component';
import {NgbCollapseModule} from "@ng-bootstrap/ng-bootstrap";
import {NavbarModule} from "../../navbar/navbar.module";

@NgModule({
  imports: [
    CommonModule,
    NgbCollapseModule,
    NavbarModule
  ],
  declarations: [FooterComponent, FooterColumnComponent],
  exports: [FooterComponent, FooterColumnComponent]
})
export class FooterModule { }
